import React, { FC } from 'react';
import { PLATZHALTER_TEXT } from '../../../../../../../../lib/constants/constant';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

const AntragAufProjektFoerderungAntragStartupProjekte: FC<{}> = () => {
	return (
		<>
			<ApplicationHeading title="Antrag auf Projektförderung" description={PLATZHALTER_TEXT} />
		</>
	);
};

export default AntragAufProjektFoerderungAntragStartupProjekte;
